
  import moment from 'moment';
  import authorByAuthorTagCode from '@/apollo/queries/blog/authorByAuthorTagCode'
  import blogsByAuthorTagCode from '@/apollo/queries/blog/blogsByAuthorTagCode'
  
  export default {
    layout: 'white',
    data() {
      return {
        blogAuthors: Array,
        blogs: Array,
        blogsMeta: Array,
        loading: 0,
        filters: {
          tagCodes: [],
          authorTagCodes: [],
        },
      };
    },
  
    computed: {
        BlogFiltersTagCodes () {
            return this.$store.getters['blog/filtersTagCodes']
        },
        BlogFiltersAuthorCodes() {
            return this.$store.getters['blog/filtersAuthorCodes']
        },
    },
    
    methods: {
      getFilterAuthor() {
        return [this.$route.params.slug]
      }
    },

    apollo: {
      $loadingKey: "loading",
      blogAuthors: {
        prefetch: true,
        query: authorByAuthorTagCode,
        variables() {
          return { currentlocale: this.$normalizeLocale(this.$i18n.locale) , tagCode: this.$route.params.slug, today: moment().format('YYYY-MM-DD')};
        },
        update(data) {
          return this.$normalizeStrapi(data.blogAuthors.data);
        },
      },
      blogs: {
        prefetch: true,
        query: blogsByAuthorTagCode,
        variables() {
          return { currentlocale: this.$normalizeLocale(this.$i18n.locale) , authorTagCode: this.$route.params.slug};
        },
        update(data) {
          this.blogsMeta = data.blogs.meta
          // return this.$normalizeStrapi(data.blogs.data);
          return this.$normalizeStrapi(data.blogs);
        },
      },
      
    },
  }
